module.exports = __webpack_public_path__ + "img/home-banner-find-products-gr.985e97da.jpg";